// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconSendPath = 'M8.843 10.698a.959.959 0 0 0-.166 1.345l2.59 3.319 5.322-11.977-12.91 2.252 2.588 3.318a.955.955 0 0 0 1.346.166l3.087-2.41 1.231 1.577-3.088 2.41Zm2.897 8.521L7.1 13.274a2.95 2.95 0 0 1-.619-2.001 2.941 2.941 0 0 1-1.79-1.087L.05 4.24 19.939.77 11.74 19.219Z';
var IconSend = baseIcon('IconSend', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconSendPath
});
export default IconSend;
//# sourceMappingURL=index.js.map